import Tabs from "@/v2-backoffice-client/components/tabs"
import { useFeatureGroupsQuery } from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.query"
import { LICENSING_VIEW_FEATURE_GROUPS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Packages tab trigger. Owns its own read of the
// groups query — Apollo dedupes it against the board's — so the count stays
// live no matter which tab is open.
function LicenseFeatureGroupTabTrigger() {
  const { data, loading } = useFeatureGroupsQuery()
  const groupCount = (data?.getFeatureGroups ?? []).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_FEATURE_GROUPS}
      iconSrc="package"
      isLoading={loading}
      count={groupCount}
    >
      Packages
    </Tabs.Trigger>
  )
}

export default LicenseFeatureGroupTabTrigger
